import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from "@mui/material";
import { forwardRef } from "react";
export const UiPopover = forwardRef((props, ref) => (_jsx(Popover, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_popover.js.map